// utils/eventBus.ts
type EventCallback<T> = (data: T) => void;

interface EventMap {
  [eventName: string]: Array<EventCallback<any>>;
}

class EventBus {
  private events: EventMap = {};

  on<T>(eventName: string, callback: EventCallback<T>): void {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback as EventCallback<any>);
  }

  emit<T>(eventName: string, data: T): void {
    if (this.events[eventName]) {
      this.events[eventName].forEach((callback) => callback(data));
    }
  }

  off<T>(eventName: string, callback: EventCallback<T>): void {
    if (this.events[eventName]) {
      this.events[eventName] = this.events[eventName].filter((cb) => cb !== callback);
    }
  }
}

// 创建单例的 eventBus 实例
const eventBusInstance = new EventBus();

// 导出单例实例
export default eventBusInstance;
